import { _js } from '@ifixit/localize';
import stepsTemplate from 'ejs/embed/embed.v4.steps.ejs';
import Template from 'Shared/template';

export function StepController(fullScreenController, prepareEmbed, zoom) {
   let template = prepareEmbed(Template.get(stepsTemplate));
   function constructStep(step, isSingle) {
      let element;

      step.stepHasTitle = step.title !== '';
      step.isSingle = isSingle;
      step.isFull = !isSingle;
      step.isImage = step.media.type === 'image';
      step.isEmbed = step.media.type === 'embed';
      step.hasMedia = !step.isImage || step.media.data.length > 0;
      step.multipleImages = step.isImage ? step.media.data.length > 1 : false;
      step.pageTitle = step.title === '' ? _js('Step') + ' ' + step.number : step.title;
      element = template(step);

      if (step.isImage) {
         /**
          * Setup thumbnail hover switching
          */
         let largeImages = element.find('.large > img');
         element.find('.js-thumbnail').mouseenter(function (event) {
            let ndx = $(this).attr('data-index');
            largeImages.hide();
            $(largeImages[ndx]).show();
         });
         largeImages.on('click', zoom);
      } else if (step.isEmbed) {
         let embedEl = element.find('#embed-' + step.stepid)[0];
         embedEl.innerHTML = step.media.data.html;
      } else {
         let videoEl = element.find('#video-' + step.stepid)[0];
      }

      if (isSingle && !fullScreenController.supported()) {
         element.find('.js-fullscreen').hide();
      }

      return element;
   }

   return {
      getElement: constructStep,
   };
}
